import { useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useMutation } from "shared/hooks/useApi";
import graphql from "utils/api/graphql";
import { PRODUCT_RANGES } from "utils/api/graphql/queries/product-range-advisor-codes";
import { INITIAL_VALUES, SCREENS } from "utils/constants";
import View from "./View";

const Delete = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const [visible, setVisible] = useState(true);
  const cancel = () => navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path);
  const [deleteProductRange] = useMutation(
    graphql.mutations.DELETE_PRODUCT_RANGE,
    {
      refetchQueries: [
        {
          query: PRODUCT_RANGES,
          awaitRefetchQueries: true,
          variables: {
            ...INITIAL_VALUES,
            orderBy: [{ code: "ASC" }],
          },
        },
      ],
      onCompleted: () => {
        setVisible(false);
        navigate(SCREENS.PRIVATE.ADMIN.PRODUCT_RANGES.LIST.path, {
          replace: true,
        });
      },
    },
  );
  const onSubmit = () => {
    return deleteProductRange({
      variables: {
        where: {
          id,
        },
      },
    });
  };
  return <View onSubmit={onSubmit} cancel={cancel} visible={visible} />;
};

export default Delete;
